

// MiniDrawerStyled.jsx
import { styled } from '@mui/material/styles';
import Drawer from '@mui/material/Drawer';
import { drawerWidth } from '../../../store/constant';

const openedMixin = (theme) => ({
  width: drawerWidth,
  borderRight: 'none',
  zIndex: 1099,
  background: '#F5F7FA',
  overflowX: 'hidden',
  boxShadow: 'none',
  transition: theme.transitions.create('width', {
    easing: 'cubic-bezier(0.4, 0, 0.2, 1)',
    duration: theme.transitions.duration.enteringScreen + 100
  })
});

const closedMixin = (theme) => ({
  borderRight: 'none',
  zIndex: 1099,
  background: '#F5F7FA',
  overflowX: 'hidden',
  width: 60,
  transition: theme.transitions.create('width', {
    easing: 'cubic-bezier(0.4, 0, 0.2, 1)',
    duration: theme.transitions.duration.leavingScreen + 100
  })
});

const MiniDrawerStyled = styled(Drawer, {
  shouldForwardProp: (prop) => prop !== 'open'
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: 'nowrap',
  boxSizing: 'border-box',
  overflowY: 'auto',
  height: '100%',
  maxHeight: 'calc(100vh - 10px)',
  '&::-webkit-scrollbar': { display: 'none' },
  scrollbarWidth: 'none',
  msOverflowStyle: 'none',
  ...(open && {
    ...openedMixin(theme),
    '& .MuiDrawer-paper': openedMixin(theme)
  }),
  ...(!open && {
    ...closedMixin(theme),
    '& .MuiDrawer-paper': closedMixin(theme)
  })
}));

export default MiniDrawerStyled;